import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import App from './App.vue'
import router from './router'
import store from './store'
import './eleui/compnts.js'

Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'wx-open-launch-app'
]
console.log(process.env)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
